import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { theme } from '../themes';
export const NavbarOfflineLink = (props) => {
    const offlineColor = theme.palette.offline.main;
    return (_jsxs(ListItem, { sx: { color: offlineColor }, children: [_jsx(ListItemIcon, { sx: { color: offlineColor }, children: props.children }), _jsx(ListItemText, { primary: props.text })] }, props.key));
};
